import { Bubble, BubbleContentProps } from 'tea-component';
import React from 'react';
import { useIntl, getLocale } from 'umi';
import {
  // getAggregationTipContent,
  getAggregationTipContentNew,
  getDataMapMetricsEnInfo,
} from './utils/aggregation';
// @ts-ignore
import { SOURCE_MAP } from '@/pages/intelligence/utils/constant';

import {
  AMEND_TYPE,
  AMEND_METRIC,
  AMEND_PLATFORM,
  RNKING_DATA_SOURCE,
  RNKING_METRIC,
} from './utils/static_data';
// import './index.less';

// props数据类型规范
interface Props {
  placement?: BubbleContentProps['placement']; // 冒泡提示位置
  DomOrText: JSX.Element[] | JSX.Element | string; // 展示的文本
  customBubbleContent?: JSX.Element[] | JSX.Element | string; // 自定义气泡内容
  style?: any; // 文案样式
  type?: 'mobile' | 'pc' | 'console' | 'company' | 'streaming' | 'combine' | string; // 游戏类型
  ratioType?: 0 | 1; // 是否百分比排序
  market?: string; // 指标名称(title)
  platform?: string; // 对应平台/数据源(icon)
  diyClassName?: string;
  cardItem?: any;
  hasPointer?: boolean; // 是否要hover手型
  showMobileDataSourceRangeInfo?: boolean; // 是否展示mobile数据源范围说明
  [keyName: string]: any; // 其他参数
}

// props的默认值
index.defaultProps = {
  placement: 'top',
  style: null,
  type: '',
  ratioType: 0,
  market: '',
  platform: '',
  hasPointer: true,
  diyClassName: '',
  AWidth: 400,
  showMobileDataSourceRangeInfo: false,
};

/**
 * 用于展示“表格特定标题/卡片”等的聚合方式提示
 */
function index(props: Props) {
  const {
    placement,
    DomOrText = null,
    customBubbleContent = null,
    style,
    type = '',
    ratioType,
    market = '',
    platform = '',
    hasPointer,
    closeOnScroll = false,
    diyClassName,
    AWidth,
    showMobileDataSourceRangeInfo = false,
    cardItem = {},
  } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  // console.log('AggregationBubble', props);

  const getUSDataSourceMetricTips = () => {
    const metricText = cardItem?.metricUserGuide;
    switch (metricText) {
      case 'digitalRevenue': {
        return formatMessage({ id: 'dbi_info_metric_us_digitalrevenue' });
      }
      case 'digitalARPPU': {
        return formatMessage({ id: 'dbi_info_metric_us_digitalARPPU' });
      }
      case 'physicalRevenue': {
        return formatMessage({ id: 'dbi_info_metric_us_physicalrevenue' });
      }
      case 'mau': {
        return formatMessage({ id: 'dbi_info_metric_global_mau' });
      }
      default: {
        return '';
      }
    }
  };

  const bubbleContent = () => {
    // 当有自定义显示内容时
    if (customBubbleContent) return customBubbleContent;

    // 当数据源为Ranking中的、或 P.Heat时
    if (
      (RNKING_DATA_SOURCE?.includes(platform?.toLowerCase()) &&
        !['PCU', 'ACU', 'Steam PCU'].includes(market)) ||
      market === 'P.Heat'
    ) {
      return getDataMapMetricsEnInfo(
        AMEND_TYPE?.[type] || type?.toString(),
        RNKING_METRIC?.[market] || market?.toString(),
        SOURCE_MAP?.[platform] || platform?.toString(),
      );
    }

    // 气泡内容提示文本
    // let _content = getAggregationTipContent(
    //   /* 参数type */
    //   AMEND_TYPE[type] || type?.toString(),
    //   /* 参数market */
    //   ['pc', 'console', 'combine'].includes(type) && market === 'MAU'
    //     ? market.toString()
    //     : AMEND_METRIC[market] || market?.toString(),
    //   /* 参数platform */
    //   type === 'company'
    //     ? 'Appannie'
    //     : AMEND_PLATFORM[platform] || platform?.toString(),
    // );

    // 气泡内容提示文本
    let _content = getAggregationTipContentNew({
      type: AMEND_TYPE[type] || type?.toString(),
      market:
        ['pc', 'console', 'combine'].includes(type) && market === 'MAU'
          ? market.toString()
          : AMEND_METRIC[market] || market?.toString(),
      platform: type === 'company' ? 'Appannie' : AMEND_PLATFORM[platform] || platform?.toString(),
      locale,
      formatMessage,
    });

    // console.log('_content', _content);

    // 百分比排序时不提示任何内容
    let _exist = ratioType === 1 ? '' : _content;

    if (!Boolean(_exist)) return '';

    if (type != 'mobile' && type != 'company') {
      _content = _content + getUSDataSourceMetricTips();
    }

    return (
      <span
        style={{ maxWidth: 818, display: 'block', boxSizing: 'border-box' }}
        dangerouslySetInnerHTML={{ __html: _content }}
      ></span>
    );
  };

  const bubbleContentInfo = bubbleContent();

  // console.log('bubbleContentInfo', bubbleContentInfo);

  return (
    <Bubble
      className={'bubble-all-bg ' + diyClassName}
      arrowPointAtCenter
      dark
      style={{ maxWidth: AWidth ? AWidth : 400 }}
      placement={placement}
      content={
        (!bubbleContentInfo && !showMobileDataSourceRangeInfo) ? null : <>
          {bubbleContentInfo}
          {showMobileDataSourceRangeInfo && (
            <>
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </>
          )}
        </>
      }
      closeOnScroll={closeOnScroll}
    >
      <span
        className={hasPointer && bubbleContentInfo ? 'cursor-pointer' : ''}
        style={style}
      >
        {DomOrText}
      </span>
    </Bubble>
  );
}

export default index;
